import { render, staticRenderFns } from "./ObkDescriptionNoIncognitoStep.vue?vue&type=template&id=267871cc&scoped=true"
import script from "./ObkDescriptionNoIncognitoStep.vue?vue&type=script&lang=js"
export * from "./ObkDescriptionNoIncognitoStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267871cc",
  null
  
)

export default component.exports